// Need to use the React-specific entry point to import createApi
import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import prepareHeaders from 'services/utils/prepare-headers';
import { UserContext } from './types';

// Define a service using a base URL and expected endpoints
export const userContextApi = createApi({
  reducerPath: 'usercontextApi',
  baseQuery: fetchBaseQuery({
    baseUrl: 'api/user',
    prepareHeaders,
  }),
  endpoints: (builder) => ({
    getUserContext: builder.query<UserContext, void>({
      query: () => `context`,
      transformResponse: (rawResult: { data: UserContext }) => rawResult.data,
      keepUnusedDataFor: 0,
    }),
  }),
});

export const { useGetUserContextQuery } = userContextApi;
